import React from "react";
import { cn } from "@/lib/utils";

interface GridContainerProps {
  children: React.ReactNode;
  columns?: {
    mobile?: 1 | 2;
    tablet?: 2 | 3;
    desktop?: 2 | 3 | 4;
  };
  gap?: "sm" | "md" | "lg";
  className?: string;
}

const GridContainer: React.FC<GridContainerProps> = ({
  children,
  columns = { mobile: 1, tablet: 2, desktop: 3 },
  gap = "md",
  className,
}) => {
  const gapClasses = {
    sm: "gap-4",
    md: "gap-6",
    lg: "gap-8",
  };

  const columnClasses = {
    mobile: columns.mobile === 2 ? "grid-cols-2" : "grid-cols-1",
    tablet: columns.tablet === 3 ? "sm:grid-cols-3" : "sm:grid-cols-2",
    desktop:
      columns.desktop === 2
        ? "lg:grid-cols-2"
        : columns.desktop === 4
          ? "lg:grid-cols-4"
          : "lg:grid-cols-3",
  };

  return (
    <div
      className={cn(
        "grid w-full",
        columnClasses.mobile,
        columnClasses.tablet,
        columnClasses.desktop,
        gapClasses[gap],
        className
      )}
    >
      {children}
    </div>
  );
};

export default GridContainer;
